import React, { useMemo } from 'react';
import { useUnitLinks } from 'core/contexts/unitLinks';
import { useTranslation } from 'react-i18next';
import { Button, Grid2, Typography } from '@mui/material';
import { Add, Backpack, SentimentVeryDissatisfied } from '@mui/icons-material';

const NoData = ({ handleOpenForm = () => {} }) => {
    const { totalExpLinksCount, resetExpLinkFilters } = useUnitLinks();
    const { t } = useTranslation();
    const hasExpLinks = useMemo(() => totalExpLinksCount > 0, [totalExpLinksCount]);
    const translate = (key) => t(`experience_units.${hasExpLinks ? 'no_data' : 'no_units'}.${key}`);

    const buttonStyles = {
        padding: '8px',
        minWidth: '48px',
        backgroundColor: hasExpLinks ? '#fff' : 'var(--color-utriper-blue)',
        borderColor: hasExpLinks ? '#13131340' : '',
        color: hasExpLinks ? '#131313' : '#fff',
        textTransform: 'none',
        fontWeight: 500,
    };

    return (
        <Grid2 container mt="32px" flexDirection="column" justifyContent="center" alignItems="center" gap="12px">
            {hasExpLinks ? <Backpack sx={{ fontSize: 72, color: 'var(--color-utriper-blue)' }} /> : <SentimentVeryDissatisfied sx={{ fontSize: 72, color: 'var(--color-utriper-blue)' }} />}
            <Grid2 container flexDirection="column" justifyContent="center" alignItems="center" gap="8px">
                <Typography fontSize={20} fontWeight={700} textAlign="center" sx={{ color: '#131313' }}>
                    {translate('title')}
                </Typography>
                <Typography fontSize={16} fontWeight={500} textAlign="center" sx={{ color: '#131313bf' }}>
                    {translate('subtitle')}
                </Typography>
            </Grid2>
            <Button sx={buttonStyles} variant={hasExpLinks ? 'outlined' : 'contained'} startIcon={totalExpLinksCount <= 0 ? <Add sx={{ color: '#fff', fontSize: '24px' }} /> : false} onClick={hasExpLinks ? resetExpLinkFilters : handleOpenForm}>
                {translate('button')}
            </Button>
        </Grid2>
    );
};

export default NoData;
